module.exports = __webpack_public_path__ + "static/media/3DPPA31.5b7f5f0d.jpg";